module.exports = __webpack_public_path__ + "img/bannertest1.0e91b702.jpg";